var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("reports-title", { attrs: { title: _vm.pageTitle } }),
      _vm._v(" "),
      _c("reports-toolbar", {
        attrs: {
          "drop-menu": _vm.menu,
          "report-title": _vm.pageTitle,
          "range-value": _vm.toolbarRange,
          "toolbar-disabled": _vm.isStatic,
        },
        on: { onSelectDropdown: _vm.onChangeCalculationMode },
      }),
      _vm._v(" "),
      _vm.isShowSkeleton
        ? _c("skeleton-wrapper", {
            attrs: { id: "skeletonWrapper" },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("vertical-bar-chart", {
                        attrs: {
                          "stub-config": _vm.stubConfig,
                          "is-static": true,
                          "custom-legends": true,
                          "show-stub-message": false,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3389063398
            ),
          })
        : _c("vertical-bar-chart", {
            attrs: {
              id: "report_export_id",
              config: _vm.chartConfig,
              "stub-config": _vm.stubConfig,
              "is-static": _vm.isStatic,
              "custom-legends": true,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }